/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import LocaleMessage from '~/components/LocaleMessage';

import getDateLocale from '~/util/GetDateLocale';
import GetPluginspaceTheme from '~/util/PluginspaceTheme';

import { Column, SettingsArea } from '../styles';
import ColorParameters from './ColorParameters';
import ContentParameters from './ContentParameters';
import FuncionalityParameters from './FuncionalityParameters';
import Preview from './Preview';

export default function TelepresenceConfig({
    app,
    setToast,
    requestError,
    updateObject,
    imageGalleriesList,
    defaultGalleries,
    handleChangeTab,
    needSaving,
    setNeedSaving,
}) {
    const theme = GetPluginspaceTheme(useTheme());
    const user_settings = useSelector(state => state.settings || null);

    const date_loc = getDateLocale(user_settings);
    const def_lang =
        date_loc && date_loc.code ? date_loc.code.replace('-', '_') : 'en_US';

    const { settings: appConfig } = app;
    const appSettings =
        appConfig && appConfig.settings
            ? appConfig.settings
            : { language: def_lang };

    const [config, setConfig] = useState(appSettings);

    const { allow_requests, password } = config;

    const visualSettings = config.visual || { text_size: 'medium' };

    const validPW = password && password.length === 6;

    const colors = [
        {
            id: 'top',
            default: theme.primary,
            value: theme.primary,
            title: 'page.applications.telepresence.form.colors.top',
        },
        {
            id: 'bottom',
            default: '#000',
            value: '#000',
            title: 'page.applications.telepresence.form.colors.bottom',
        },
        ...(allow_requests
            ? [
                  {
                      id: 'call_button',
                      default: theme.primary,
                      value: theme.primary,
                      title:
                          'page.applications.telepresence.form.colors.button',
                  },
              ]
            : []),
        ...(visualSettings.show_text
            ? [
                  {
                      id: 'text',
                      default: '#ffffff',
                      value: '#ffffff',
                      title: 'page.applications.telepresence.form.colors.text',
                  },
              ]
            : []),
    ];

    const def_colors = {};
    colors.forEach(c => {
        const { id: i, default: d } = c;
        def_colors[i] = d;
    });

    const defImageGalleries = defaultGalleries.images || [];
    const galleriesList = [...imageGalleriesList, ...defImageGalleries];

    const [currFile, setCurrFile] = useState(null);

    function setSettings(key, val) {
        setConfig({
            ...config,
            [key]: val,
        });
        setNeedSaving(true);
    }

    function setVisualSettings(key, val) {
        setSettings('visual', {
            ...visualSettings,
            [key]: val,
        });
        setNeedSaving(true);
    }

    return (
        <Column>
            <SettingsArea className="row col-12 mt-5">
                <div className="col-md-6 col-12" style={{ margin: '20px' }}>
                    <FuncionalityParameters
                        settings={config}
                        setSettings={(k, v) => setSettings(k, v)}
                    />
                    <ColorParameters
                        colors={colors}
                        settings={visualSettings}
                        setSettings={(k, v) => setVisualSettings(k, v)}
                    />
                    <ContentParameters
                        settings={visualSettings}
                        galleries={galleriesList}
                        updateFile={f => setCurrFile(f)}
                        setToast={toast => setToast(toast)}
                        handleError={error => requestError(error)}
                        setSettings={(k, v) => setVisualSettings(k, v)}
                    />
                </div>
                <div className="col-md-5 col-12 container">
                    <LocaleMessage msg="label.preview" />
                    <Preview
                        configuration={config}
                        file={currFile}
                        def_colors={def_colors}
                        onCallClick={e => {
                            if (!needSaving) {
                                handleChangeTab(e, 'contacts');
                            }
                        }}
                    />
                </div>
                <Button
                    className="col-md-8 col-12 p-3 mt-5"
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    disabled={!needSaving || !validPW}
                    onClick={() => updateObject({ ...app, settings: config })}
                >
                    <LocaleMessage msg="button.save" />
                </Button>
            </SettingsArea>
        </Column>
    );
}

TelepresenceConfig.defaultProps = {
    imageGalleriesList: [],
    defaultGalleries: {},
};

TelepresenceConfig.propTypes = {
    app: PropTypes.object.isRequired,
    updateObject: PropTypes.func.isRequired,
    imageGalleriesList: PropTypes.array,
    defaultGalleries: PropTypes.object,
    requestError: PropTypes.func.isRequired,
    handleChangeTab: PropTypes.func.isRequired,
    setToast: PropTypes.func.isRequired,
    needSaving: PropTypes.bool.isRequired,
    setNeedSaving: PropTypes.func.isRequired,
};
